// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"da891f13","239":"22d2efa4","453":"1027094b","455":"10d760d8"}[chunkId] + ".chunk.js";
};